@if (items && items.length) {
  <div class="d-block col-12 px-0 w-100 carousel-wrapper" [ngClass]="{'carousel__custom-arrow': type==='promotion-course'}"
    >
    <lib-swiper [slides]="items" [ngClass]="type" [options]="config" (reachEnd)="onReachEnd()">
      <ng-template swiperContent let-item="item">
        @switch (type) {
          @case (CarouselType.DASHBOARD_ITEM) {
            <app-dashboard-item
              [item]="item"
              [progressShow]="true"
              [startButton]="item.isNextRecommended"
              [paymentEnabled]="isPaymentEnabled"
              [inCarousel]="true"
              (click)="navigate(item, $event)">
            </app-dashboard-item>
          }
          @case (CarouselType.WEBINAR) {
            <app-event-card
              [item]="item"
              [disabled]="true"
              class="event-card"
              (click)="navigate(item, $event)">
            </app-event-card>
          }
          @default {
            <lib-course-card
              [data]="item"
              [paymentEnabled]="isPaymentEnabled"
              [showDetailsButton]="courseDetailsEnabled"
              [extended]="extendedCard"
              (cardClick)="navigate(item, $event)"
              (buttonClick)="navigate(item, $event)"
              (detailsClick)="openDetails(item)">
            </lib-course-card>
          }
        }
      </ng-template>
    </lib-swiper>
  </div>
}
